let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fuAjW")).then(() => parcelRequire('7cokY'));